import axios from "axios";
import { getBaseURL, getTokens } from "../helpers/HelperFunctions";

export default class ApiService {
    async login(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Auth/login", data);
    }

    async otp(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Auth/doctor", data);
    }

    async bulkdDleteReports(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/bulk-delete", data);
    }

    async addUser(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/User/register", data);
    }

    async deleteReport(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/delete", data);
    }

    async getAllUsers() {
        const ax = await this.ax();
        return await ax.get("/api/User/all");
    }

    async getUsers() {
        const ax = await this.ax();
        return await ax.get("/api/User/all");
    }

    async getPermission(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Role/page", data);
    }

    async updateUser(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/User/update", data);
    }

    async updateUserStatus(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/User/update-status", data);
    }

    async getReports() {
        const ax = await this.ax();
        return await ax.get("/api/Document/doctor-documents");
    }

    async saveDocument(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/add", data);
    }

    async updateDocumentStatus(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/update-status", data);
    }

    async updateDocument(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/update", data);
    }

    async getStageUsers(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/stage-users", data);
    }

    async assignUser(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/assign-user", data);
    }

    async completeStage(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/complete-stage", data);
    }

    async logout() {
        const ax = await this.ax();
        return await ax.get("/api/Auth/logout");
    }

    async addMedia(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/add-media", data);
    }

    async getAllPermissions() {
        const ax = await this.ax();
        return await ax.get("/api/Role/all");
    }

    async savePermissions(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Role/save", data);
    }

    async getAnalyticsData(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/analytics", data);
    }

    async getDocumentsSummary(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/summary", data);
    }

    async getDocumentsMonthlyStatistics() {
        const ax = await this.ax();
        return await ax.get("/api/Document/monthly-statistics");
    }

    async getIndividualContribution(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/individual-contribution", data);
    }

    async getLineStatistics(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/statistics-line", data);
    }

    async getBarStatistics(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/statistics-bar", data);
    }

    async addAppointment(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Appointment/add", data);
    }

    async bulkUploadAppointments(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Appointment/bulk-upload", data);
    }

    async getAppointmentByDateRange(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Appointment/get-by-range", data);
    }

    async getAppointmentById(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Appointment/get-by-id", data);
    }

    async updateAppointment(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Appointment/update", data);
    }

    async getDoctorDocuments() {
        const ax = await this.ax();
        return await ax.get("/api/Document/doctor-documents");
    }

    async getRequestedChangesById(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/RequestedChanges/get-requested-changes", data);
    }

    async requestChanges(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/request-changes", data);
    }

    async completeDocument(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/complete", data);
    }

    async updateReport(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/update", data);
    }

    async getClinicsByDoctorId(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Clinic/get-clinics-by-id", data);
    }

    async resetPassword(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Auth/reset", data);
    }

    async getAssignees() {
        const ax = await this.ax();
        return await ax.get("/api/Document/assignees");
    }

    async getDocumentById(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/Document/get-document", data);
    }

    async addReport(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/add", data);
    }

    async addStaffMember(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/StaffMember/add-staff", data);
    }

    async getAssignedDoctors() {
        const ax = await this.ax();
        return await ax.get("/api/StaffMember/assigned");
    }

    async getStaffMemberById(data: {}) {
        const ax = await this.ax();
        return await ax.post("/api/StaffMember/get-staff-member", data);
    }

    async updateSupportStaff(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/StaffMember/update", data);
    }

    async getDocumentStatistics(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/statistics", data);
    }

    async getDocumentBarChartStatistics(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/chart-statistics", data);
    }

    async reopenDocument(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/open", data);
    }

    async getPriorities() {
        const ax = await this.ax();
        return await ax.get("/api/Priority/all");
    }

    async getPatient() {
        const ax = await this.ax();
        return await ax.get("/api/Patient/get-by-doctor");
    }

    async getReferrers() {
        const ax = await this.ax();
        return await ax.get("/api/Referrer/all");
    }

    async getReportTypesByDoctorIdOrClinicId(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/ReportType/get-report-types", data);
    }

    async deleteAppointment(data: any) {
        const ax = await this.ax();
        return await ax.get("/api/Appointment/delete/" + data);
    }

    async forgetPassword(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Auth/forget-password", data);
    }

    async generateLink(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Document/generate-link", data);
    }

    async getApppointmetByDocumentId(data: any) {
        const ax = await this.ax();
        return await ax.post("/api/Appontment/get-by-document-id", data);
    }

    private async ax() {

        let baseUlr = getBaseURL();

        return axios.create({
            baseURL: baseUlr,
            timeout: 60000,
            headers: {
                Authorization: `Bearer ${getTokens().jwt}`,
                "Content-Type": "application/json",
            }
        });
    }
}